import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';
import './Header.css';

const Header = ({ language, setLanguage, t }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`header visible ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo" onClick={() => scrollToSection('hero')}>
          <span className="logo-text">Chalhoub Trade</span>
        </div>

        <nav className="nav">
          <button className="nav-link" onClick={() => scrollToSection('services')}>
            {t.nav.services}
          </button>
          <button className="nav-link" onClick={() => scrollToSection('why-partner')}>
            {t.nav.whyUs}
          </button>
          <button className="nav-link" onClick={() => scrollToSection('contact')}>
            {t.nav.contact}
          </button>
        </nav>

        <div className="header-actions">
          <div className="lang-select" aria-label="Language">
            <Globe size={18} />
            <select value={language} onChange={(e) => setLanguage(e.target.value)}>
              <option value="en">English</option>
              <option value="de">Deutsch</option>
              <option value="ar">العربية</option>
            </select>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;